"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DeletionInteractionHandler_drawingToolsManager, _DeletionInteractionHandler_eventEngine, _DeletionInteractionHandler_geometryMathManager, _DeletionInteractionHandler_viewport;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeletionInteractionHandler = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
class DeletionInteractionHandler {
    // #endregion Properties (4)
    // #region Constructors (1)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(drawingToolsManager, interactionManager) {
        // #region Properties (4)
        _DeletionInteractionHandler_drawingToolsManager.set(this, void 0);
        _DeletionInteractionHandler_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _DeletionInteractionHandler_geometryMathManager.set(this, void 0);
        _DeletionInteractionHandler_viewport.set(this, void 0);
        __classPrivateFieldSet(this, _DeletionInteractionHandler_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _DeletionInteractionHandler_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _DeletionInteractionHandler_geometryMathManager, drawingToolsManager.geometryMathManager, "f");
    }
    // #endregion Constructors (1)
    // #region Public Methods (2)
    deletePoint(ray) {
        var _a;
        if (!__classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").settings.general.enableDeletion)
            return;
        // check if there is a point close to the ray
        const distances = __classPrivateFieldGet(this, _DeletionInteractionHandler_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").positionArray);
        if (distances) {
            const idx = distances[0].index;
            if ((_a = __classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").settings.geometry.disabledPoints) === null || _a === void 0 ? void 0 : _a.includes(idx))
                return;
            __classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").removePoint(idx);
            __classPrivateFieldGet(this, _DeletionInteractionHandler_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.REMOVED, {
                viewportId: __classPrivateFieldGet(this, _DeletionInteractionHandler_viewport, "f").id,
                drawingToolsId: __classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").uuid,
            });
        }
    }
    deleteSelection(indices) {
        if (!__classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").settings.general.enableDeletion)
            return;
        const toDelete = indices.filter((i) => {
            var _a;
            return !((_a = __classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").settings.geometry.disabledPoints) === null || _a === void 0 ? void 0 : _a.includes(i));
        });
        if (toDelete.length === 0)
            return;
        __classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").removePoints(toDelete);
        __classPrivateFieldGet(this, _DeletionInteractionHandler_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE_DRAWING_TOOLS.REMOVED, {
            viewportId: __classPrivateFieldGet(this, _DeletionInteractionHandler_viewport, "f").id,
            drawingToolsId: __classPrivateFieldGet(this, _DeletionInteractionHandler_drawingToolsManager, "f").uuid,
        });
    }
}
exports.DeletionInteractionHandler = DeletionInteractionHandler;
_DeletionInteractionHandler_drawingToolsManager = new WeakMap(), _DeletionInteractionHandler_eventEngine = new WeakMap(), _DeletionInteractionHandler_geometryMathManager = new WeakMap(), _DeletionInteractionHandler_viewport = new WeakMap();
//# sourceMappingURL=DeletionInteractionHandler.js.map